var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/00/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.92 11.62C17.872 11.4973 17.801 11.3851 17.71 11.29L12.71 6.29C12.617 6.19676 12.506 6.1228 12.384 6.07234C12.262 6.0188 12.132 5.99591 12 5.99591C11.734 5.99591 11.478 6.1017 11.29 6.29C11.197 6.38324 11.123 6.49393 11.072 6.61575C11.022 6.73758 10.996 6.86814 10.996 7C10.996 7.2663 11.102 7.517 11.29 7.71L14.59 11H7C6.735 11 6.48 11.1054 6.293 11.2929C6.105 11.4804 6 11.7348 6 12C6 12.2652 6.105 12.5196 6.293 12.7071C6.48 12.8946 6.735 13 7 13H14.59L11.29 16.29C11.196 16.383 11.122 16.4936 11.071 16.6154C11.02 16.7373 10.994 16.868 10.994 17C10.994 17.132 11.02 17.2627 11.071 17.3846C11.122 17.5064 11.196 17.617 11.29 17.71C11.383 17.8037 11.494 17.8781 11.615 17.9289C11.737 17.9797 11.868 18.0058 12 18.0058C12.132 18.0058 12.263 17.9797 12.385 17.9289C12.506 17.8781 12.617 17.8037 12.71 17.71L17.71 12.71C17.801 12.6149 17.872 12.5028 17.92 12.38C18.02 12.1365 18.02 11.8635 17.92 11.62Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.0d13b28f.svg";
export { ForwardRef as ReactComponent };